<div class="row mb-3" [ngClass]="{'type-b': templateSuffix !== ''}">
  <div class="col" *ngFor="let tab of tabs; let i = index"  >
    <div [ngClass]="{ d: step < tab.step }" >
      <div class="titulo"> {{ i+1 }}.  {{ tab.title }} </div>
      <div class="linea"></div>
    </div>
  </div>
</div>
